import React, {useRef, useEffect, useState} from "react";
import PropTypes from "prop-types";

const ExportButton = ({exportOptions}) => {
    const [opened, setOpened] = useState(false);
    let ref = useRef(null);

    const close = () => {
        setOpened(false);
    };

    const toggle = () => {
        setOpened(!opened);
    };

    const onClickOutsideElement = event => {
        if (ref.current && !ref.current.contains(event.target)) {
            // Clicked outside of the menu
            if (opened) {
                close();
            }
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", onClickOutsideElement);
        window.addEventListener("resize", close);
        return () => {
            document.removeEventListener("mousedown", onClickOutsideElement);
            window.removeEventListener("resize", close);
        };
    }, [ref, opened]);

    const mapToExportOption = (option, index) => (
        <li key={"export-" + index} className="dropdown-item export-option" role="none">
            <button type="button" role="menuitem" data-testid={"export-option-" + index}
                    onClick={option.exportFunction}>{option.name}</button>
        </li>)

    return (
        <span ref={ref} className="dropdown-span export-block" data-testid="export-dropdown">
            <button type="button" className="export-button gridletExportToggle" title="Export"
                    aria-label="Export" aria-haspopup="menu" aria-expanded={opened}
                    data-testid="export-button" onClick={toggle}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                    <path d="M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7zm-6 .67 2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z" />
                </svg>
            </button>
            {opened ?
                <ul className="dropdown-menu show export-options gridletExportMenu"
                    role="menu" aria-label="Export" data-testid="export-menu">
                    {exportOptions.map(mapToExportOption)}
                </ul> : ''}
    </span>
    )
};
ExportButton.propTypes = {
    exportOptions: PropTypes.array,
};

export default ExportButton;